__turbopack_context__.v({
  "closed": "RcqufG_closed",
  "currentHours": "RcqufG_currentHours",
  "scheduleDetails": "RcqufG_scheduleDetails",
});
